import React from 'react';
import {render} from 'react-dom';

import {initArticleReactionsAndComments} from '../modules/card-counters';
import {localGet} from '../services/ajax/promise';
import {addListenerByShareContainer, onCopyLink} from '../services/content-type/share';
import {TrendPage} from '../website-ui/pages/trend';

const rootTrend = document.getElementById('js-root-trend');

if (rootTrend) {
  render(<TrendPage />, rootTrend);
}

const $loadButton = document.querySelector('.js-load-button');
const $trend = document.querySelector('.js-trend');
const isMobile = window.Site.targeting.platform === 'smartphone';

let page = 2;

$loadButton?.addEventListener('click', event => {
  event.preventDefault();

  $loadButton.disabled = true;
  localGet(`${window.location.pathname}?page=${page}`)
    .then(JSON.parse)
    .then(({data, ajaxData}) => {
      if (data) {
        $loadButton.insertAdjacentHTML('beforebegin', data);
        page = page + 1;
      }

      if (!ajaxData?.isVisibleLoadMoreBtn) {
        $loadButton.style.display = 'none';
      }

      $loadButton.disabled = false;
      initArticleReactionsAndComments();
    })
    .catch(error => {
      $loadButton.disabled = false;
      console.error(error);
    });
});

if (isMobile) {
  addListenerByShareContainer($trend, $trend?.querySelector('.js-share'));
} else {
  onCopyLink($trend, 'trend-link');
}
